import { Stack, Accordion, AccordionSummary, AccordionDetails, Typography, Chip } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import dayjs from "dayjs";
import { useQuestionnaireContext } from "../../../../contexts/QuestionnaireContext";
import { CondutasAccordion } from "./CondutasAccordion";
import { GenericTimeline } from "../GenericTimeline";
import { useState } from "react";

const style: any = {
  Realizada: "#007C6D",
  Concluído: "#007C6D",
  Parcialmente: "#FBBB3C",
  "Não realizada": "#EF4352",
  Falhou: "#EF4352",
};

export function CondutasHistory({ selectedField }: any) {
  const { historyValues } = useQuestionnaireContext();

  const responseEntries = historyValues?.map((el: any) => el?.resource);

  const condutasReponses = responseEntries?.map((el: any) => {
    const awnserDate = el?.authored;
    const filterItens = el?.item
      ?.filter((e: any) => e?.text === "Condutas")?.[0]
      ?.item?.filter((subItem: any) => {
        return (
          subItem?.item?.[1]?.answer?.[0]?.valueCoding &&
          subItem?.item?.[0]?.answer
        );
      });
    const displayReferences = el?.item?.filter(
      (e: any) => e?.linkId === "displayReferences"
    )?.[0]?.item;
    const displayInfo = {
      healthcare: displayReferences?.[0]?.answer?.[0]?.valueString || "",
      practitioner: displayReferences?.[1]?.answer?.[0].valueString || "",
    };
    return { awnserDate, filterItens, displayInfo };
  });

  const verifyResponse = condutasReponses?.filter(
    (el: any) => el.filterItens?.length
  );

  // Agrupa respostas por dia
  const groupedByDay = verifyResponse?.reduce((acc: any, item: any) => {
    const day = dayjs(item.awnserDate).format("DD/MM/YYYY");
    if (!acc[day]) {
      acc[day] = {
        day,
        awnserDate: item.awnserDate,
        items: [],
      };
    }
    acc[day].items.push(item);
    return acc;
  }, {}) || {};

  // Converte para array para usar na timeline
  const timelineData = Object.values(groupedByDay);

  return (
    <Stack spacing={1}>
      <GenericTimeline
        data={timelineData}
        dotColor={style}
        component={(data: any, index: number) => (
          <DayAccordion 
            day={data.day} 
            items={data.items} 
            style={style} 
            defaultExpanded={index === 0} 
          />
        )}
      />
    </Stack>
  );
}

// Componente Accordion que agrupa condutas por dia
function DayAccordion({ day, items, style, defaultExpanded }: any) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  // Conta o total de condutas dentro de todos os questionários do dia
  const totalCondutas = items.reduce((total: number, item: any) => {
    return total + (item?.filterItens?.length || 0);
  }, 0);

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      sx={{
        width: "100%",
        boxShadow: "1px 1px 16px 1px rgba(0, 0, 0, 0.1)",
        border: "1px solid",
        borderColor: "neutral200.main",
        borderRadius: 1,
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Stack direction="row" alignItems="center" spacing={2} width="100%">
          <Chip 
            label={`${totalCondutas} ${totalCondutas === 1 ? 'conduta' : 'condutas'}`}
            size="small"
            sx={{ fontWeight: 500 }}
          />
        </Stack>
      </AccordionSummary>
      
      <AccordionDetails>
        <Stack spacing={1}>
          {items.map((data: any, idx: number) => (
            <CondutasAccordion key={idx} style={style} data={data} index={idx} />
          ))}
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
